import { UniformEntryPage } from "src/pages/uniform-entry/uniform-entry-page";

import { init } from "../../init-streaming";
init(UniformEntryPage);
